import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import ClientDashboard from "./pages/ClientDashboard";
import AdvisorDashboard from "./pages/AdvisorDashboard";
import CursorGlow from "./components/CursorGlow";
import "./App.css";

function App() {
  return (
    <div className="App min-h-screen bg-[#020617] text-white">
      <CursorGlow />
      <Toaster theme="dark" position="top-right" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard/client" element={<ClientDashboard />} />
          <Route path="/dashboard/advisor" element={<AdvisorDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
